export default __webpack_public_path__ + "static/media/fav.00215d75.svg";